import { useEffect } from "react";
import { useLang } from "@/lib/i18n";

// Sets html[lang] attribute so CSS font rules apply,
// but deliberately does NOT toggle dir="rtl" on <html> to avoid
// mirroring the entire layout. Individual text elements use dir="auto".
export default function LangAttrSync() {
  const { lang } = useLang();
  useEffect(() => {
    document.documentElement.setAttribute("lang", lang);
    document.documentElement.setAttribute("dir", "ltr"); // layout always LTR
  }, [lang]);
  return null;
}
